var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlarmSystem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-47,.cls-48,.cls-49,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58{fill:none;}.cls-2{clip-path:url(#clippath-8);}.cls-3{clip-path:url(#clippath-7);}.cls-4{clip-path:url(#clippath-6);}.cls-5{clip-path:url(#clippath-9);}.cls-6{clip-path:url(#clippath-5);}.cls-7{clip-path:url(#clippath-3);}.cls-8{clip-path:url(#clippath-4);}.cls-9{clip-path:url(#clippath-2);}.cls-10{clip-path:url(#clippath-1);}.cls-11{isolation:isolate;}.cls-59{fill:#027180;}.cls-60{fill:#014750;}.cls-61{fill:#eee;}.cls-62{fill:#f0f0f0;}.cls-63{fill:#fff;}.cls-64{fill:#ffe2b1;}.cls-65{fill:#fff5ee;}.cls-66{fill:#ec5021;}.cls-67{fill:#ffd07e;}.cls-68{fill:#e3a67b;}.cls-69{fill:#993844;}.cls-70{fill:#979797;}.cls-71{fill:#015a66;}.cls-72{fill:#b5d0ee;}.cls-73{fill:#b8cae9;}.cls-74{fill:#858585;}.cls-75{fill:#bfbfbf;}.cls-76{fill:#c0e0e4;}.cls-77{fill:#cacaca;}.cls-78{fill:#c58a67;}.cls-79{fill:#de5740;}.cls-80{fill:#e0e0e0;}.cls-81{fill:#e1f1ff;}.cls-82{fill:#171b28;}.cls-83{fill:#242937;}.cls-84{fill:#41939e;}.cls-85{fill:#191919;}.cls-86{fill:gray;}.cls-87{fill:#762e22;}.cls-88{fill:#7b3023;}.cls-89{fill:#5280a7;}.cls-12{clip-path:url(#clippath-13);}.cls-13{clip-path:url(#clippath-14);}.cls-14{clip-path:url(#clippath-12);}.cls-15{clip-path:url(#clippath-11);}.cls-16{clip-path:url(#clippath-18);}.cls-17{clip-path:url(#clippath-19);}.cls-18{clip-path:url(#clippath-17);}.cls-19{clip-path:url(#clippath-16);}.cls-20{clip-path:url(#clippath-10);}.cls-21{clip-path:url(#clippath-15);}.cls-22{clip-path:url(#clippath-25);}.cls-23{clip-path:url(#clippath-22);}.cls-24{clip-path:url(#clippath-23);}.cls-25{clip-path:url(#clippath-24);}.cls-26{clip-path:url(#clippath-21);}.cls-27{clip-path:url(#clippath-20);}.cls-28{clip-path:url(#clippath-45);}.cls-29{clip-path:url(#clippath-40);}.cls-30{clip-path:url(#clippath-42);}.cls-31{clip-path:url(#clippath-41);}.cls-32{clip-path:url(#clippath-44);}.cls-33{clip-path:url(#clippath-43);}.cls-34{clip-path:url(#clippath-46);}.cls-35{clip-path:url(#clippath-47);}.cls-36{clip-path:url(#clippath-49);}.cls-37{clip-path:url(#clippath-48);}.cls-38{clip-path:url(#clippath-34);}.cls-39{clip-path:url(#clippath-30);}.cls-40{clip-path:url(#clippath-32);}.cls-41{clip-path:url(#clippath-33);}.cls-42{clip-path:url(#clippath-35);}.cls-43{clip-path:url(#clippath-36);}.cls-44{clip-path:url(#clippath-39);}.cls-45{clip-path:url(#clippath-37);}.cls-46{clip-path:url(#clippath-29);}.cls-47{clip-path:url(#clippath-26);}.cls-48{clip-path:url(#clippath-28);}.cls-49{clip-path:url(#clippath-27);}.cls-50{clip-path:url(#clippath-38);}.cls-51{clip-path:url(#clippath-31);}.cls-52{clip-path:url(#clippath-52);}.cls-53{clip-path:url(#clippath-51);}.cls-54{clip-path:url(#clippath-55);}.cls-55{clip-path:url(#clippath-50);}.cls-56{clip-path:url(#clippath-54);}.cls-57{clip-path:url(#clippath-53);}.cls-58{clip-path:url(#clippath);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "91.77 29.95 91.91 29.95 91.91 62.13 53.85 81.17 53.85 48.98 53.99 48.84 91.77 29.95"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "6.13 25.05 53.85 48.98 53.85 81.17 6.13 57.24 6.13 25.05"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "73.02 23.79 91.77 29.95 53.99 48.84 73.02 23.79"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "53.85 77.67 53.85 83.82 6.13 59.89 6.13 53.74 53.85 77.67"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m14.95,36.38l9.94,4.9v12.45l-9.94-4.9v-12.45Zm-1.82-3.22v17.07l13.57,6.72v-17.07l-13.57-6.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "11.03 32.05 13.13 33.17 13.13 50.38 11.03 51.92 11.03 32.05"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "13.13 50.38 13.13 50.38 26.7 57.1 26.7 59.75 11.03 51.92 13.13 50.38"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "14.95 48.98 24.88 53.88 24.88 41.42 14.95 36.38 14.95 48.98"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "14.53 36.24 15.78 36.8 15.78 48.42 14.53 49.26 14.53 36.24"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "15.78 48.42 15.78 48.42 24.88 52.9 24.88 54.44 14.53 49.26 15.78 48.42"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "91.91 58.63 91.91 64.93 53.85 83.82 53.85 77.67 91.91 58.63"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "59.03 75.01 70.08 69.55 70.08 45.48 59.03 50.94 59.03 75.01"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "72.32 44.36 72.32 69.41 70.08 68.43 70.08 45.48 72.32 44.36"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m84.36,53.46l-6.16,3.08v-12.45l6.16-3.08v12.45Zm-8.12-10.92v17.07l9.8-4.9v-17.07l-9.8,4.9Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-14"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "88.41 36.66 86.17 37.78 86.17 54.86 88.41 56.4 88.41 36.66"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-15"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "86.17 54.86 86.17 54.86 76.24 59.75 76.24 62.41 88.41 56.4 86.17 54.86"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-16"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "84.36 53.46 78.2 56.54 78.2 43.94 84.36 41 84.36 53.46"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "84.78 40.72 83.52 41.28 83.52 52.9 84.78 53.74 84.78 40.72"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-18"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "83.52 52.9 83.52 52.9 78.2 55.56 78.2 56.96 84.78 53.74 83.52 52.9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m60.43,62.13c0,.7.42,1.12,1.12.84.56-.28,1.12-1.12,1.12-1.82s-.42-1.12-1.12-.84c-.56.28-1.12,1.12-1.12,1.82Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m61.13,62.41c0,.7.42,1.12,1.12.84.56-.28,1.12-1.12,1.12-1.82s-.42-1.12-1.12-.84c-.7.28-1.12,1.12-1.12,1.82Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m36.78,47.44l9.8,4.9v12.31l-9.8-4.9v-12.31Zm-1.82-3.08v16.93l13.43,6.72v-16.93l-13.43-6.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-22"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "32.72 43.24 34.96 44.36 34.96 61.15 32.72 62.69 32.72 43.24"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-23"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "34.96 61.15 34.96 61.15 48.39 67.87 48.39 70.53 32.72 62.83 32.72 62.69 34.96 61.15"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-24"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "36.78 59.75 46.57 64.65 46.57 52.34 36.78 47.44 36.78 59.75"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "36.36 47.3 37.48 47.86 37.48 59.33 36.36 60.17 36.36 47.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-26"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "37.48 59.33 37.48 59.33 46.57 63.81 46.57 65.21 36.36 60.17 37.48 59.33"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-27"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "59.03 73.75 70.08 68.57 72.32 69.41 59.03 75.99 59.03 73.75"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-28"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "68.54 83.54 81.84 76.83 78.48 75.15 65.32 81.86 68.54 83.54"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-29"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "65.32 81.86 78.48 75.15 78.48 72.63 65.32 79.35 65.32 81.86"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-30"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "68.54 86.34 81.84 79.63 81.84 76.83 68.54 83.54 68.54 86.34"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-31"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "72.32 69.41 78.48 72.63 65.32 79.35 59.03 75.99 72.32 69.41"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-32"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "59.03 81.31 68.54 86.34 68.54 83.54 65.32 81.86 65.32 79.35 59.03 75.99 59.03 81.31"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-33"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "97.65 32.19 76.1 25.33 25.02 0 49.51 8.4 97.65 32.19"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-34"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "2.35 29.25 50.35 53.18 76.1 25.33 25.02 0 2.35 29.25"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-35"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "50.35 54.72 50.35 53.18 2.35 29.25 2.35 30.37 50.35 54.72"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-36"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "50.35 54.72 50.35 53.18 76.1 25.33 97.65 32.19 97.65 33.17 76.52 26.45 50.35 54.72"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-37"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "33.42 6.58 29.22 4.48 29.22 10.78 33.42 12.87 33.42 6.58"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-38"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "23.48 16.93 29.22 10.78 29.22 4.48 23.48 7.42 23.48 16.93"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m29.22,4.48l-5.74,2.94,4.2,2.1,5.74-2.94-4.2-2.1Zm0,.84l2.66,1.26-4.2,2.1-2.66-1.26,4.2-2.1Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-40"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "27.68 19.03 23.48 16.93 23.48 7.42 27.68 9.52 27.68 19.03"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-41"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "27.68 19.03 33.42 12.87 33.42 6.58 27.68 9.52 27.68 19.03"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m91.52,26.79c.05-.03.1-.05.15-.08l1.46.85c-.05.03-.1.06-.15.08-.44-.25-1.02-.59-1.46-.85Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-43"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m91.68,26.71c1.38-.79,2.3-3.02,1.66-4.1l1.46.85c.64,1.08-.29,3.3-1.66,4.1-.44-.25-1.02-.59-1.46-.85Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-44"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m84.62,28.11c.63-.37,1.17-1.27,1.22-2.08l1.46.85c-.05.81-.58,1.71-1.22,2.08-.03.02-.06.03-.09.05-.29.14-.55.14-.75.03l-1.46-.85c.2.11.45.11.75-.03.03-.02.06-.03.09-.05Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m85.83,26.03c.03-.48-.12-.82-.37-.97l1.46.85c.25.15.4.49.37.97-.44-.25-1.02-.59-1.46-.85Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-46"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m85.46,25.06l1.46.85c-.2-.11-.46-.11-.75.03-.03.02-.06.03-.09.05l-1.46-.85s.06-.03.09-.05c.29-.14.55-.14.75-.03Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-47"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m85.23,29.03l-1.46-.85c-.26-.15-.4-.49-.37-.96.05-.81.58-1.71,1.22-2.08l1.46.85c-.63.37-1.17,1.27-1.22,2.08-.03.47.12.82.37.96Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-48"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m77.73,34.56l-1.46-.85c.3.17.71.18,1.19-.06l1.46.85c-.48.23-.89.23-1.19.06Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-49"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m74.94,34.81c.49.28.97.56,1.46.85.11.14.24.26.39.35l-1.46-.85c-.15-.09-.28-.2-.39-.35Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-50"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m74.66,34.3c.49.28.97.56,1.46.85.07.19.16.36.27.5-.49-.28-.97-.56-1.46-.85-.11-.14-.2-.31-.27-.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-51"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m77.73,34.56l-1.46-.85c-.61-.35-.77-1.41-.22-2.65l1.46.85c-.55,1.24-.39,2.3.22,2.65Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-52"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m86.75,11.75l1.46.85c.13.08.25.19.35.35l-1.46-.85c-.09-.16-.21-.27-.35-.35Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-53"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m74.66,34.3c-.27-.75-.19-1.84.35-3.05l1.46.85c-.55,1.21-.62,2.3-.35,3.05-.49-.28-.97-.56-1.46-.85Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m86.75,11.75l1.46.85c-.36-.21-.85-.14-1.33.14-.58.33-1.16.97-1.54,1.81l-1.46-.85c.38-.84.96-1.48,1.54-1.81.49-.28.97-.35,1.33-.14Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-55"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m87.39,10.29l1.46.85c-.53-.31-1.25-.21-1.97.2-.85.49-1.7,1.43-2.26,2.66l-1.46-.85c.56-1.23,1.41-2.16,2.26-2.66.72-.42,1.44-.51,1.97-.2Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Alarm_system"
  }, /*#__PURE__*/React.createElement("g", {
    id: "House_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m49.82,86.28l39.5-20.51c1.22-.72,1.22-2.49,0-3.21l-47.64-25.11c-.58-.34-1.31-.34-1.89,0L2.81,59.56c-1.2.71-1.22,2.45-.03,3.18l45.12,23.52c.59.36,1.32.37,1.92.02Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 46.85,
    y: 22.95,
    width: 52.06,
    height: 65.21
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: -0.87,
    y: 18.05,
    width: 61.71,
    height: 70.11
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 46.99,
    y: 16.79,
    width: 51.78,
    height: 39.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: -0.87,
    y: 46.74,
    width: 61.71,
    height: 44.08
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 6.13,
    y: 26.17,
    width: 27.57,
    height: 37.78
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 4.03,
    y: 25.05,
    width: 16.09,
    height: 33.87
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 4.03,
    y: 43.38,
    width: 29.67,
    height: 23.37
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 7.95,
    y: 29.39,
    width: 23.93,
    height: 31.49
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 7.53,
    y: 29.25,
    width: 15.25,
    height: 27.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 7.53,
    y: 41.42,
    width: 24.35,
    height: 20.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 46.85,
    y: 51.64,
    width: 52.06,
    height: 39.18
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 52.03,
    y: 38.48,
    width: 25.05,
    height: 43.52
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 63.08,
    y: 37.36,
    width: 16.23,
    height: 39.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 69.24,
    y: 30.65,
    width: 23.79,
    height: 35.96
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 79.18,
    y: 29.67,
    width: 16.23,
    height: 33.73
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 69.24,
    y: 47.86,
    width: 26.17,
    height: 21.55
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 71.2,
    y: 34.01,
    width: 20.15,
    height: 29.53
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 76.52,
    y: 33.73,
    width: 15.25,
    height: 27.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 71.2,
    y: 45.9,
    width: 20.57,
    height: 18.05
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 53.43,
    y: 53.23,
    width: 16.23,
    height: 16.83
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 54.13,
    y: 53.51,
    width: 16.23,
    height: 16.83
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 27.96,
    y: 37.36,
    width: 27.43,
    height: 37.64
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 25.72,
    y: 36.24,
    width: 16.23,
    height: 33.45
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 25.72,
    y: 54.16,
    width: 29.67,
    height: 23.37
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 29.78,
    y: 40.44,
    width: 23.79,
    height: 31.21
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 29.36,
    y: 40.3,
    width: 15.11,
    height: 26.87
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 29.36,
    y: 52.34,
    width: 24.21,
    height: 19.87
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 52.03,
    y: 61.57,
    width: 27.29,
    height: 21.41
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 58.33,
    y: 68.15,
    width: 30.51,
    height: 22.39
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 58.33,
    y: 65.63,
    width: 27.15,
    height: 23.23
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 61.55,
    y: 69.83,
    width: 27.29,
    height: 23.51
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-51"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 52.03,
    y: 62.41,
    width: 33.45,
    height: 23.93
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 52.03,
    y: 68.99,
    width: 23.51,
    height: 24.35
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "97.65 32.19 76.1 25.33 25.02 0 49.51 8.4 97.65 32.19"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 18.02,
    y: -7,
    width: 86.62,
    height: 46.18
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "2.35 29.25 50.35 53.18 76.1 25.33 25.02 0 2.35 29.25"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: -4.65,
    y: -7,
    width: 87.74,
    height: 67.17
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: -4.65,
    y: 22.25,
    width: 61.99,
    height: 39.46
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 43.35,
    y: 18.33,
    width: 61.29,
    height: 43.38
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 22.22,
    y: -2.52,
    width: 18.19,
    height: 22.39
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 16.48,
    y: -2.52,
    width: 19.73,
    height: 26.45
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 16.48,
    y: -2.52,
    width: 23.93,
    height: 19.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 16.48,
    y: 0.42,
    width: 18.19,
    height: 25.61
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 20.68,
    y: -0.42,
    width: 19.73,
    height: 26.45
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Thief"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-61",
    cx: 82.66,
    cy: 98.33,
    rx: 3.62,
    ry: 1.67
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-61",
    cx: 90.63,
    cy: 97.26,
    rx: 3.62,
    ry: 1.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "m91.32,71.37c-.08,1.12-.21,2.34,0,2.7.16.26,1.5,1.58,2.23,2.29,0,0,.1-.18.51-.18,0,0-1.99-2.03-2.28-2.46-.29-.43-.06-2.71-.34-3.15-.06.16-.11.28-.14.36.01.11.02.25,0,.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.33,74.08c-.22-.37-.09-1.59,0-2.7.01-.19,0-.33,0-.44-.02.06-.04.09-.04.09,0,0-.19.1-.39.2-.03.01-.06.03-.1.04-.17.95-.5,2.81-.6,3.2-.15.53,0,2.18,0,2.18,0,0-2.66-1.3-3.09-1.59-.43-.28-.04-1.89-.11-2.16-.07-.26-.57-1.04-.67-.85-.1.18.1,2.95.3,3.21.2.26,3.88,2.04,3.88,2.04.01-.52-.06-1.47-.05-2.53.1.16.22.32.35.41.35.23,2.49,1.82,2.49,1.82,0,0-.08-.43.28-.62-.73-.71-2.07-2.03-2.23-2.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "m93.27,77.02l-.19-.25s0,0,0,0c0,0,0,0,0,0,.03-.05.16-.25.38-.41.04-.03.07-.05.12-.07,0,0,0,0,0,0,.02-.01.04-.02.06-.03,0,0,0,0,0,0,.02,0,.04-.02.06-.03,0,0,0,0,0,0,.02,0,.04-.01.06-.02,0,0,0,0,.01,0,.02,0,.04-.01.07-.02,0,0,0,0,0,0,.02,0,.04,0,.06-.01,0,0,.01,0,.02,0,.02,0,.05,0,.07,0,0,0,.29.3.29.3-.41.05-.99.54-1.04.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "m93.39,77.94l.1.04s0,0,.02-.02c.17-.07.29-.28.34-.46l-.04-.03s0-.01,0-.02c-.05-.2-.61-.48-.61-.48l.43-.35.44-.15s0,0,0,0c.06,0,.82-.09,1.19.09.1.05.17.12.19.21.16.75.35.98.14,1.3,0,0-.18.28-.38.52h-.02s-.04.06-.06.09c-.08.1-.16.18-.23.23-.04.02-.09.04-.14.06-.23.04-.56-.02-.56-.02l-.98-.6s-.22-.29-.16-.51l.04.02.07.05c.07.01.14.03.21.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "m89.8,96.81c.75.23,1.42,1.13,1.87,1.33s1.07.27,1.52.09c.29-.11.48-.23.58-.31,0-.12-.03-.24-.04-.29-.02-.08-1.55-1.44-1.87-1.75-.32-.31-.49-1.04-.49-1.04,0,0-.2-.17-.44-.22-.2-.05-.42-.01-.57.27-.03.06-.06.11-.1.15,0,.01-.02.02-.02.03-.03.04-.07.08-.11.12,0,0-.01.01-.02.02-.04.03-.07.06-.11.09,0,0-.02.01-.02.02-.04.03-.08.05-.13.08-.01,0-.02.01-.03.02-.04.02-.08.04-.12.06,0,0,0,0,0,0-.04.02-.08.03-.12.04,0,0-.02,0-.02,0-.04.01-.07.02-.11.03,0,0,0,0,0,0-.03,0-.06.02-.09.02-.05.01-.09.01-.09.01,0,0-.44-.03-.71.09-.12.05-.21.14-.21.28,0,.07,0,.13,0,.19.37.55.77.44,1.47.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "m82.75,95.41s-.06,0-.09.02c-.03,0-.07.02-.1.04-.02,0-.04.01-.06.02-.04.02-.09.04-.13.06-.01,0-.02,0-.03.02-.05.03-.1.06-.16.1,0,0,0,0,0,0-.16.11-.31.25-.44.39-.01.01-.02.02-.03.04-.51.04-1.16-.71-1.16-.71-.1.21-.18.5-.18.79.07.53.47.55.91.9.53.41.64.91,1.02,1.4.38.49,1.26.66,1.67.65.41,0,.72-.32.73-.33.02-.04.04-.09.06-.12.06-.13.04-.28-.05-.4-.36-.45-1.29-1.69-1.34-2.39-.02-.32-.18-.46-.39-.48-.05,0-.1,0-.15,0-.02,0-.05,0-.07.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "m82.3,98.47c-.38-.49-.49-.98-1.02-1.4-.44-.34-.84-.37-.91-.9,0,.16.02.31.08.45.13.31.48.47.69.67.47.47.88,1.48,1.43,1.77.55.28,1.32.41,1.69.25.19-.08.34-.31.43-.51,0,0-.32.32-.73.33-.41,0-1.29-.16-1.67-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "m93.19,98.23c-.45.18-1.07.11-1.52-.09s-1.12-1.1-1.87-1.33c-.71-.22-1.1-.11-1.47-.66.01.56.42.9,1.09.95.74.05,1.55.87,1.87,1.14.32.27,1.13.42,1.45.4.32-.02.9-.4,1-.5.04-.04.05-.13.04-.22-.1.07-.29.2-.58.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "m81.7,96.1s.02-.02.03-.04c.45-3.33,3.17-6.67,3.79-8.75.63-2.14.89-5.12.99-5.99.1-.87-2.09-.68-3.09-.98-.28-.08-.46.06-.58.32.18,1.91.65,5.05.88,5.94,0,.53-1.35,2.83-1.85,4.16-.62,1.64-1.33,4.62-1.33,4.62,0,0,.64.75,1.16.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "m89.26,95.6s.03,0,.09-.01c.03-.11.08-.2.08-.2,0,0,.37-.34.31-3.41-.03-1.56-.08-3.28.09-6.54.11-2.07-.44-4.35-.83-4.67-.57-.47-1.13,1.5-1.4,2.64.31,1.18.71,2.79.76,3.53.08,1.22-.3,2.82-.16,4.25.14,1.42.04,4.33.35,4.49.27-.12.71-.09.71-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m88.99,80.78c.39.32.94,2.59.83,4.67-.17,3.25-.12,4.98-.09,6.54.05,3.06-.31,3.41-.31,3.41,0,0-.04.09-.08.2.03,0,.06-.01.09-.02,0,0,0,0,0,0,.03,0,.07-.02.11-.03,0,0,.02,0,.02,0,.04-.01.08-.03.12-.04,0,0,0,0,0,0,.04-.02.08-.04.12-.06.01,0,.02-.01.03-.02.04-.02.08-.05.13-.08,0,0,.02-.01.02-.02.04-.03.07-.06.11-.09,0,0,.01-.01.02-.02.04-.04.08-.08.11-.12,0,0,.02-.02.02-.03.04-.05.07-.1.1-.15.15-.28.37-.32.57-.27.02-1.41-.45-6.48-.02-8.9.29-1.63-.01-5.32-.29-6.77-.41-.12-.83-.28-1.2-.44-.06.04-.13.09-.2.13-.02.01-.03.02-.05.03-.06.04-.12.08-.18.12,0,0-.02.01-.03.02,0,0,0,0,0,0-.07.04-.14.09-.21.13-.02.01-.03.02-.05.03-.06.04-.12.07-.18.11-.02,0-.03.02-.05.03-.07.04-.15.09-.22.13-.02,0-.03.02-.05.03-.06.04-.13.07-.19.1-.02.01-.04.02-.06.03-.08.04-.15.08-.23.12,0,0-.02,0-.02.01-.07.04-.14.07-.21.1-.02.01-.04.02-.06.03-.07.03-.14.07-.2.1,0,0-.01,0-.02.01-.07.03-.15.07-.22.1-.02,0-.04.02-.06.02-.06.02-.12.05-.17.07-.01,0-.03.01-.04.02-.07.03-.13.05-.2.07-.02,0-.03.01-.05.02-.05.02-.1.03-.15.05-.02,0-.03,0-.05.01-.06.02-.12.03-.18.04,0,0-.02,0-.03,0-.05,0-.09.02-.14.02-.01,0-.03,0-.04,0-.05,0-.1,0-.14,0-.97,0-2.57-.12-2.96-.83,0,.27.02.71.07,1.26.12-.25.3-.4.58-.32,1,.3,3.19.11,3.09.98-.1.87-.36,3.85-.99,5.99-.61,2.08-3.33,5.42-3.79,8.75.12-.15.28-.29.44-.39,0,0,0,0,0,0,.05-.03.1-.07.16-.1.01,0,.02,0,.03-.02.04-.02.09-.05.13-.06.02,0,.04-.01.06-.02.03-.01.07-.03.1-.04.03,0,.06-.01.09-.02.02,0,.05-.01.07-.01.05,0,.1,0,.15,0,.45-2.11,3.25-7.23,3.57-8.09.33-.9.68-5.27.68-5.27,0,0,.17.59.38,1.38.27-1.14.83-3.11,1.4-2.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "m91.44,68.77c-.31-.09-1.06-.44-1.06,0,0,.37.21.57.51.54s.48-.04.63.05c.11.07.22.07.34.03.06-.2.11-.4.16-.59-.12-.06-.3.05-.58-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "m91.33,69.85c-.32.1-.92.09-1.59-.31-.24-.14-.49-.28-.72-.44.18.39.39.83.62,1.21.37.62,1.06.68,1.78.35.01-.03.02-.05.03-.08.1-.25.22-.59.34-.96-.15.17-.1.12-.46.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "m88.59,68.74c-.23-.25-.41-.58-.47-1.03-.01.14-.02.28,0,.43,0,.08.01.16.03.24-.15.09-.64.08-.64.08-.04.39.02.71.12.98.71.57.88-.21.97-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "m89.31,70.5c.04.07.08.14.13.2.01.02.03.04.04.06.03.04.06.08.1.12.02.02.04.04.06.06.03.03.06.06.09.09.02.02.04.04.06.05.03.02.06.04.08.06.11.08.22.14.31.18,0,0,0,0,0,0,.11.04.2.06.27.06.02,0,.05,0,.08-.02.01,0,.02,0,.04-.01.02,0,.04-.01.06-.02.02,0,.03-.01.05-.02.01,0,.03-.01.05-.02.02,0,.04-.02.07-.03.03-.01.07-.03.1-.04.2-.09.39-.2.39-.2,0,0,.01-.03.04-.09.03-.06.06-.16.11-.27-.72.33-1.41.26-1.78-.35-.23-.39-.44-.82-.62-1.21-.15-.11-.3-.23-.43-.37-.09.49-.25,1.28-.97.7.37.91,1.38,1.15,1.68,1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "m89.99,65.74c-1.04.13-1.76.93-1.87,1.97.06.45.24.78.47,1.03.13.14.28.26.43.37.23.16.49.3.72.44.67.41,1.27.41,1.59.31.36-.11.31-.06.46-.23.02-.07.05-.15.07-.23-.12.04-.23.04-.34-.03-.14-.09-.32-.09-.63-.05-.31.04-.51-.17-.51-.54,0-.44.75-.09,1.06,0,.29.08.46-.03.58.03.07-.28.12-.56.14-.8.08-1.14-.92-2.42-2.18-2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "m94.07,78.17c-.2-.09-.54-.13-.54-.13,0,0-.05-.26-.04-.38.01-.11-.43-.25-.55-.29-.11-.04-.5.45-.6.49-.1.04-.66.05-.66.05,0,0-.43.61-.24,1.22,0,0,.98.38,1.19.54.19.16,1.11-.27,1.15-.27,0-.06.47-1.15.28-1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "m93.79,79.41s0,0,0,0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "m91.69,77.92l-.66-.34c-.27.07-.38.42-.39.77,0,.26.04.51.13.65.46.11.69.14.69.14-.19-.62.24-1.22.24-1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.63,78.35c-.06-.01-.16-.03-.27-.06-.07-.02-.16-.03-.25-.05-.07-.02-.14-.03-.22-.05-.05-.01-.11-.02-.16-.04-.06-.01-.11-.03-.17-.04-.09-.02-.18-.04-.27-.06-.62-.15-1.36-.33-2.03-.53-.07-.02-.13-.04-.2-.06-.07-.02-.13-.04-.2-.06-.19-.06-.38-.12-.55-.18-.06-.02-.11-.04-.17-.06-.03-.01-.05-.02-.08-.03-.08-.03-.15-.06-.22-.09-.19-.08-.34-.16-.45-.23-.14-.09-.26-.27-.37-.51-.02-.05-.05-.11-.07-.17-.02-.06-.04-.12-.07-.18-.01-.04-.03-.08-.04-.12-.02-.06-.04-.12-.05-.18-.08-.28-.14-.59-.2-.92,0-.05-.02-.1-.03-.14-.02-.12-.04-.23-.06-.35,0-.04-.01-.08-.02-.13-.01-.08-.02-.17-.04-.25,0-.04-.01-.08-.02-.13-.01-.08-.02-.17-.03-.25,0-.04-.01-.08-.02-.12-.06-.49-.12-.95-.16-1.33,0-.06-.01-.11-.02-.17,0-.03,0-.06-.01-.1,0-.05-.01-.11-.02-.15,0-.04-.01-.09-.02-.12-.01-.07-.02-.13-.03-.17,0-.02,0-.03-.01-.04,0-.03-.01-.05-.02-.07-.01-.03-.02-.05-.03-.05,0,0,0,0-.01,0-.05,0-.11.15-.17.4,0,0,0,.02,0,.03-.01.05-.02.11-.04.17,0,0,0,.02,0,.03-.01.06-.02.13-.04.19,0,0,0,.02,0,.03,0,.05-.02.1-.03.15-.01.06-.02.12-.03.18,0,.05-.02.1-.02.15-.02.12-.04.25-.06.39,0,.06-.02.12-.02.18-.02.17-.04.34-.06.51,0,.06-.01.12-.02.18,0,.07-.01.14-.02.21-.01.13-.03.26-.04.39-.01.12-.02.23-.03.34,0,0,0,0,0,.01,0,.05,0,.1-.01.16,0,0,0,0,0,0-.01.19-.02.35-.02.49,0,.14,0,.25.01.33.02.1.04.22.08.34.06.17.14.34.24.52.03.05.06.1.1.15.3.44.77.84,1.41.99.02,0,.03,0,.05.01,0,0,.01,0,.02,0,.01,0,.02,0,.04,0,0,0,.02,0,.03,0,.01,0,.02,0,.04,0,0,0,.02,0,.03,0,.01,0,.03,0,.04.01.01,0,.02,0,.03,0,.01,0,.03,0,.04.01.01,0,.02,0,.04.01.01,0,.03,0,.04.01.01,0,.03,0,.04.01.01,0,.03,0,.04.01.01,0,.03,0,.04.01.01,0,.03,0,.04.01.02,0,.03,0,.05.01.01,0,.03,0,.04.01.02,0,.03.01.05.02.02,0,.03,0,.05.01.02,0,.03.01.05.02.02,0,.03,0,.05.01.02,0,.04.01.06.02.01,0,.03,0,.04.01.02,0,.04.01.06.02.01,0,.03,0,.04.01.02,0,.05.01.07.02,0,0,0,0,0,0,.72.23,1.66.54,2.57.85,0,0,0,0,0,0,0,0,.02-.01.03-.02.06-.04.12-.08.18-.12.02-.01.03-.02.05-.03.07-.04.13-.09.2-.13.36.15.79.32,1.2.44.05.01.09.03.14.04-.08-.14-.13-.4-.13-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "m86.32,77.95s-.03,0-.04-.01c-.02,0-.04-.01-.06-.02-.01,0-.03,0-.04-.01-.02,0-.04-.01-.06-.02-.02,0-.03,0-.05-.01-.02,0-.03-.01-.05-.02-.02,0-.03,0-.05-.01-.02,0-.03-.01-.05-.02-.01,0-.03,0-.04-.01-.02,0-.03,0-.05-.01-.01,0-.03,0-.04-.01-.01,0-.03,0-.04-.01-.01,0-.03,0-.04-.01-.01,0-.03,0-.04-.01-.01,0-.03,0-.04-.01-.01,0-.02,0-.04-.01-.01,0-.03,0-.04-.01-.01,0-.02,0-.03,0-.01,0-.03,0-.04-.01,0,0-.02,0-.03,0-.01,0-.02,0-.04,0,0,0-.02,0-.03,0-.01,0-.02,0-.04,0,0,0-.01,0-.02,0-.02,0-.03,0-.05-.01-.64-.15-1.1-.55-1.41-.99-.03-.05-.07-.1-.1-.15-.1-.17-.18-.35-.24-.52-.04-.12-.07-.23-.08-.34-.01-.07-.02-.18-.01-.32,0-.14,0-.31.02-.49,0,0,0,0,0,0,0-.05,0-.1.01-.16,0,0,0,0,0-.01,0-.11.02-.22.03-.34.01-.13.02-.25.04-.39,0-.07.01-.14.02-.21,0-.06.01-.12.02-.18.02-.17.04-.34.06-.51,0-.06.02-.12.02-.18.02-.13.04-.26.06-.39,0-.05.02-.1.02-.15,0-.06.02-.12.03-.18,0-.05.02-.1.03-.15,0,0,0-.02,0-.03.01-.07.02-.13.04-.19,0,0,0-.02,0-.03.01-.06.02-.11.04-.17,0,0,0-.02,0-.03.06-.25.12-.4.17-.4,0,0,0,0,.01,0,.01,0,.02.03.03.05,0,.02.01.04.02.07,0,.01,0,.03.01.04.01.05.02.11.03.17,0,.04.01.08.02.12,0,.05.01.1.02.15,0,.03,0,.06.01.1,0,.05.01.11.02.17.05.37.1.84.16,1.33,0,.04.01.08.02.12.01.08.02.17.03.25,0,.04.01.08.02.13.01.08.02.17.04.25,0,.04.01.08.02.13.02.12.04.24.06.35,0,.05.02.1.03.14.06.33.13.64.2.92.02.06.03.12.05.18.01.04.03.08.04.12.02.06.04.13.07.18.02.06.05.11.07.17.11.24.23.42.37.51.11.08.27.15.45.23.07.03.14.06.22.09.03.01.05.02.08.03.05.02.11.04.17.06.17.06.36.12.55.18.06.02.13.04.2.06.07.02.13.04.2.06.68.2,1.41.38,2.03.53.09.02.18.04.27.06.06.01.12.03.17.04.06.01.11.02.16.04.08.02.15.03.22.05.09.02.18.04.25.05.11.02.2.04.27.06,0-.35.12-.7.39-.77l-.54-.28s-3.68-1.78-3.88-2.04-.4-3.03-.3-3.21c.1-.18.61.59.67.85.07.26-.32,1.87.11,2.16.43.28,3.09,1.59,3.09,1.59,0,0-.15-1.65,0-2.18.11-.39.44-2.25.6-3.2-.02,0-.04.02-.07.03-.02,0-.03.01-.05.02-.02,0-.03.01-.05.02-.02,0-.04.01-.06.02-.01,0-.02,0-.04.01-.03,0-.06.01-.08.02-.06,0-.16-.01-.27-.06,0,0,0,0,0,0-.1-.04-.2-.1-.31-.18-.03-.02-.06-.04-.08-.06-.02-.02-.04-.03-.06-.05-.03-.03-.06-.06-.09-.09-.02-.02-.04-.04-.06-.06-.03-.04-.07-.08-.1-.12-.01-.02-.03-.04-.04-.06-.05-.06-.09-.13-.13-.2-.39.12-1.97-.33-1.81-2.03,0,0,.48,0,.64-.08-.01-.08-.02-.16-.03-.24-3.47.38-4.52,1.57-5.06,4.42-.51,2.72-.05,4.7-.27,5.96.38,1.48,3.2,1.46,4.3.88,1.1-.58-.48-1.36-.49-1.36-.07-.02-.14-.05-.21-.07,0,0,0,0,0,0-.02,0-.05-.01-.07-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m87.09,79.4c-1.1.58-3.93.6-4.3-.88-.02.1-.04.19-.06.28-.07.24-.04.44.05.61.39.7,1.99.83,2.96.83.04,0,.09,0,.14,0,.01,0,.03,0,.04,0,.04,0,.09-.01.14-.02,0,0,.02,0,.03,0,.06-.01.12-.03.18-.04.02,0,.03,0,.05-.01.05-.01.1-.03.15-.05.02,0,.03,0,.05-.02.07-.02.13-.05.2-.07.01,0,.03-.01.04-.02.06-.02.11-.05.17-.07.02,0,.04-.02.06-.02.07-.03.14-.06.22-.1,0,0,.01,0,.02-.01.07-.03.14-.06.2-.1.02-.01.04-.02.06-.03.07-.03.14-.07.21-.1,0,0,.02,0,.02-.01.08-.04.15-.08.23-.12.02-.01.04-.02.06-.03.06-.03.13-.07.19-.1.02,0,.03-.02.05-.03.08-.04.15-.09.22-.13.02,0,.03-.02.05-.03.06-.04.12-.07.18-.11.02-.01.03-.02.05-.03.07-.04.14-.09.21-.13-.82-.28-1.67-.56-2.35-.78,0,0,1.59.78.49,1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m92.56,79.63c-.09-.05-.17-.12-.26-.16-.03-.01-.05-.03-.07-.05l-.09.15c-.08.12-.04.27.08.35.12.07.28.04.35-.08l.1-.16s-.07-.03-.11-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m93.24,78.15c.11.07.24.08.37.07l.16-.25c.08-.12.04-.27-.08-.35-.12-.07-.28-.04-.35.08l-.18.28c0,.07.01.14.08.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m93.46,77.78c.15-.29.32-.56.49-.83.09-.14.17-.27.26-.41.05-.07.09-.14.14-.2.05-.06.11-.12.19-.17.04-.02.08,0,.1.03,0,.01.01.03,0,.04,0,.09-.04.17-.07.24-.04.07-.08.14-.13.21-.08.14-.17.27-.26.41-.18.27-.36.54-.55.79-.03.04-.1.05-.14.02-.04-.03-.05-.08-.03-.13Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m45.41,88.3c0,.28-.04.54-.12.81-.68,2.41-4.4,4.24-8.88,4.24s-8.2-1.84-8.89-4.24c-.08-.26-.12-.53-.12-.81,0-2.79,4.03-5.05,9-5.05s9,2.26,9,5.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "m45.44,86.21c0,.23-.03.46-.1.69-.58,2.05-3.75,3.62-7.57,3.62s-6.99-1.57-7.57-3.62c-.07-.22-.1-.45-.1-.69,0-2.38,3.43-4.31,7.67-4.31s7.67,1.93,7.67,4.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m45.44,87.58c0,2.38-3.43,4.31-7.67,4.31s-7.67-1.93-7.67-4.31c0-.23.03-.46.1-.69.59,2.05,3.75,3.62,7.57,3.62s6.99-1.57,7.57-3.62c.07.22.1.45.1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "m41.59,73.2c0,1.13-1.73,2.04-3.85,2.04s-3.85-.91-3.85-2.04,1.73-2.04,3.85-2.04,3.85.91,3.85,2.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m41.59,73.2v13.06c0,1.13-1.73,2.04-3.85,2.04s-3.85-.91-3.85-2.04v-13.06c0,1.13,1.73,2.04,3.85,2.04s3.85-.91,3.85-2.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "38.35 74.66 34.53 73.31 34.53 66.33 38.17 67.42 38.35 74.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "40.86 66.4 40.86 73.31 38.35 74.66 38.17 67.42 40.86 66.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "40.86 66.4 38.17 67.42 34.53 66.33 36.53 64.8 40.86 66.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "m38.35,70.51s-2.25,1.24-3.89-1.31c0-1.89.73-1.89.73-1.89l1.09.87c-1.16,1.13,2.07,2.33,2.07,2.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m38.35,70.51v4.11c-2.8.69-3.89-1.2-3.89-1.2v-4.22c1.63,2.55,3.89,1.31,3.89,1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "m41.59,52.22c0,1.13-1.73,2.04-3.85,2.04s-3.85-.91-3.85-2.04,1.73-2.04,3.85-2.04,3.85.91,3.85,2.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m41.59,52.22v13.06c0,1.13-1.73,2.04-3.85,2.04s-3.85-.91-3.85-2.04v-13.06c0,1.13,1.73,2.04,3.85,2.04s3.85-.91,3.85-2.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "38.35 53.39 34.53 52.05 34.53 45.06 38.17 46.15 38.35 53.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "40.86 45.14 40.86 52.05 38.35 53.39 38.17 46.15 40.86 45.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "40.86 45.14 38.17 46.15 34.53 45.06 36.53 43.54 40.86 45.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "m38.35,49.25s-2.25,1.24-3.89-1.31c0-1.89.73-1.89.73-1.89l1.09.87c-1.16,1.13,2.07,2.33,2.07,2.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m38.35,49.25v4.11c-2.8.69-3.89-1.2-3.89-1.2v-4.22c1.63,2.55,3.89,1.31,3.89,1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m50.95,57.27c-2.4-1.86-27.22-21.45-27.22-21.45l1.95-16.03c.01-.1.03-.2.04-.3l26.44,20.03c-.09.36-.15.73-.2,1.1l-1.8,14.76c-.09.77.24,1.46.78,1.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "m68.01,30.33c-.58-.65-1.52-.95-2.45-.6l-7.35,2.85c-3.06,1.18-5.3,3.79-6.05,6.94l-26.44-20.03c.46-2.9,2.34-5.38,5.03-6.59l6.23-2.8c1.62-.73,3.51-.52,4.93.53l25.19,18.69c.37.28.68.62.91,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "m53.01,42.55l9.79,7.45,1.57-.54s.88-3.24,2.73-5.61l-1.12,9.17-12.39,4.34-.68.23c-.11.04-.22.06-.32.09-.01,0-.02,0-.03,0-.23.03-.48.03-.73-.02-.04,0-.09-.02-.13-.03-.04,0-.07-.02-.11-.03-.01,0-.03,0-.04-.01-.02,0-.03-.01-.05-.02-.03-.01-.07-.03-.1-.04-.01,0-.02,0-.04-.02-.05-.02-.11-.05-.16-.08-.04-.02-.09-.05-.13-.08-.04-.03-.08-.06-.13-.09-.54-.42-.87-1.11-.78-1.89l1.8-14.76c.05-.37.11-.74.2-1.1.75-3.14,3-5.75,6.05-6.94l7.35-2.85c.92-.36,1.87-.05,2.45.6,0,0,0,0,0,0,.39.65.56,1.42.46,2.2l-.31,2.55c-1.76-1.36-3.15-2.43-3.15-2.43,0,0-1.39-.9-2.63-.61-1.25.29-8.16,1.75-9.37,10.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "m68.25,53.9c-2.24,3.14-5.77,4.51-8.11,3.23,0,0-.02,0-.05-.02-.03-.01-.06-.03-.1-.06-.07-.05-.15-.1-.22-.15-.73-.52-1.23-1.28-1.5-2.18-.58-1.94-.05-4.54,1.56-6.81,1.51-2.12,3.6-3.43,5.52-3.66.96-.12,1.88.03,2.66.48l.29.19c2.32,1.65,2.29,5.68-.07,8.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "m67.14,53.11c-1.65,2.31-4.25,3.32-5.98,2.38,0,0-.02,0-.03-.02-.02,0-.04-.02-.07-.04-.05-.04-.11-.07-.16-.11-.54-.39-.91-.94-1.1-1.61-.42-1.43-.04-3.35,1.15-5.02,1.11-1.56,2.65-2.53,4.07-2.7.71-.09,1.39.02,1.96.36l.21.14c1.71,1.22,1.69,4.19-.05,6.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m66.47,52.86c-1.5,2.1-3.86,3.02-5.42,2.16,0,0-.01,0-.03-.01-.02,0-.04-.02-.07-.04-.05-.03-.1-.07-.15-.1-.49-.35-.82-.86-1-1.46-.39-1.3-.03-3.04,1.04-4.56,1.01-1.42,2.41-2.29,3.7-2.45.53-.07,1.05,0,1.5.19.1.04.19.08.28.14l.19.12s.09.07.14.11c1.41,1.16,1.35,3.76-.18,5.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m68.02,44.72c-.78-.45-1.7-.6-2.66-.48-1.92.24-4.01,1.55-5.52,3.66-1.61,2.27-2.14,4.87-1.56,6.81.26.9.76,1.66,1.5,2.18.07.05.15.1.22.15-.69-.41-3.55-2.26-4.42-2.83-.16-.11-.25-.16-.25-.16-2.32-1.66-2.29-5.68.07-8.99,2.36-3.31,6.15-4.65,8.48-3l4.16,2.66Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-67",
    cx: 63.31,
    cy: 50.66,
    rx: 1.98,
    ry: 1.3,
    transform: "translate(-17.64 55.21) rotate(-41.88)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-67",
    cx: 65.47,
    cy: 52.13,
    rx: 0.68,
    ry: 0.44,
    transform: "translate(-18.08 57.02) rotate(-41.88)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-67",
    cx: 63.16,
    cy: 54.01,
    rx: 0.68,
    ry: 0.44,
    transform: "translate(-19.92 55.97) rotate(-41.88)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-67",
    cx: 60.79,
    cy: 53.95,
    rx: 0.68,
    ry: 0.44,
    transform: "translate(-20.49 54.37) rotate(-41.88)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-67",
    cx: 60.27,
    cy: 51.94,
    rx: 0.68,
    ry: 0.44,
    transform: "translate(-19.27 53.51) rotate(-41.88)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-67",
    cx: 66.71,
    cy: 49.29,
    rx: 0.68,
    ry: 0.44,
    transform: "translate(-15.86 57.13) rotate(-41.88)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "m66.65,46.95c-.03.15-.13.32-.28.45-.28.25-.64.3-.8.12-.16-.18-.07-.53.21-.78.08-.07.17-.13.26-.16.1.04.19.08.28.14l.19.12s.09.07.14.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m74.64,40.06c-2.16-1.68-5.23-.1-5.23-.1-.72.26-1.38.72-1.99,1.31-2.96,2.87-4.62,8.73-4.62,8.73l-9.79-7.45c1.21-8.75,8.13-10.22,9.37-10.51,1.24-.29,2.63.61,2.63.61,0,0,1.39,1.07,3.15,2.43,1.94,1.49,4.34,3.33,5.83,4.45.23.17.44.35.64.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "m76.7,44.11l-1.75.52s-1.06-3.64-4.18-3.19c-.11.02-.23.04-.34.07h0c-.16.03-.33.08-.5.14-1.12.39-2.06,1.22-2.83,2.21-1.85,2.37-2.73,5.61-2.73,5.61l-1.57.54s1.66-5.86,4.62-8.73c.61-.59,1.27-1.06,1.99-1.31,0,0,3.08-1.58,5.23.1,0,0,0,0,.01,0,1.06.96,1.57,1.94,1.82,2.69.02.05.03.1.04.15.02.07.04.15.06.21.01.05.02.1.03.15.07.33.09.59.1.73,0,.02,0,.04,0,.06,0,.03,0,.05,0,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m74.96,44.63l-4.18-3.19c3.12-.45,4.18,3.19,4.18,3.19Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "m92.98,27.64l-1.46-.85c.05-.03.1-.05.15-.08l1.46.85c-.05.03-.1.06-.15.08"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "m93.13,27.55l-1.46-.85c1.38-.79,2.3-3.02,1.66-4.1l1.46.85c.64,1.08-.29,3.3-1.66,4.1"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "m85.23,29.03l-1.46-.85c.2.11.45.11.75-.03.03-.02.06-.03.09-.05.63-.37,1.17-1.27,1.22-2.08l1.46.85c-.05.81-.58,1.71-1.22,2.08-.03.02-.06.03-.09.05-.29.14-.55.14-.75.03"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "m87.29,26.88l-1.46-.85c.03-.48-.12-.82-.37-.97l1.46.85c.25.15.4.49.37.97"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "m86.08,25.99l-1.46-.85s.06-.03.09-.05c.29-.14.55-.14.75-.03l1.46.85c-.2-.11-.46-.11-.75.03-.03.02-.06.03-.09.05"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "m85.23,29.03l-1.46-.85c-.26-.15-.4-.49-.37-.96.05-.81.58-1.71,1.22-2.08l1.46.85c-.63.37-1.17,1.27-1.22,2.08-.03.47.12.82.37.96"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "m86.08,25.99s.06-.03.09-.05c.67-.33,1.17.09,1.12.94-.05.81-.58,1.71-1.22,2.08-.03.02-.06.03-.09.05-.67.33-1.17-.1-1.12-.94.05-.81.58-1.71,1.22-2.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-86",
    points: "85.27 25.09 83.82 24.24 85.77 23.29 87.23 24.13 85.27 25.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "78.92 34.5 77.47 33.66 91.52 26.79 92.98 27.64 78.92 34.5"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "m77.73,34.56l-1.46-.85c.3.17.71.18,1.19-.06l1.46.85c-.48.23-.89.23-1.19.06"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-86",
    points: "87.23 24.13 85.77 23.29 86.26 15.36 87.72 16.21 87.23 24.13"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "m76.79,36l-1.46-.85c-.89-.52-1.14-2.08-.31-3.9l1.46.85c-.82,1.82-.58,3.38.31,3.9"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "m76.79,36l-1.46-.85c-.89-.52-1.14-2.08-.31-3.9l1.46.85c-.82,1.82-.58,3.38.31,3.9"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "94.8 23.46 93.34 22.61 87.1 12.11 88.55 12.95 94.8 23.46"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "m77.73,34.56l-1.46-.85c-.61-.35-.77-1.41-.22-2.65l1.46.85c-.55,1.24-.39,2.3.22,2.65"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "85.27 25.09 83.82 24.24 84.31 16.31 85.77 17.15 85.27 25.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "85.77 17.15 84.31 16.31 86.26 15.36 87.72 16.21 85.77 17.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-79",
    points: "85.77 17.15 87.72 16.21 87.23 24.13 85.27 25.09 85.77 17.15"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-52"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "m88.55,12.95l-1.46-.85c-.09-.16-.21-.27-.35-.35l1.46.85c.13.08.25.19.35.35"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-57"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "m76.79,36l-1.46-.85c-.89-.52-1.14-2.08-.31-3.9l1.46.85c-.82,1.82-.58,3.38.31,3.9"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-86",
    points: "77.51 31.91 76.06 31.07 83.88 13.7 85.33 14.55 77.51 31.91"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-56"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "m85.33,14.55l-1.46-.85c.38-.84.96-1.48,1.54-1.81.49-.28.97-.35,1.33-.14l1.46.85c-.36-.21-.85-.14-1.33.14-.58.33-1.16.97-1.54,1.81"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "m94.8,23.46c.64,1.08-.29,3.3-1.66,4.1-.05.03-.1.06-.15.08l-14.06,6.87c-1.45.71-2.24-.74-1.41-2.59l7.82-17.37c.38-.84.96-1.48,1.54-1.81.67-.39,1.33-.37,1.68.22l6.25,10.5Zm-7.57.68l.49-7.93-1.95.95-.5,7.93,1.96-.95m.06,2.74c.05-.85-.45-1.26-1.12-.94-.03.02-.06.03-.09.05-.63.37-1.17,1.27-1.22,2.08-.05.84.45,1.26,1.12.94.03-.02.06-.03.09-.05.63-.37,1.17-1.27,1.22-2.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "76.47 32.1 75.02 31.25 83.16 13.15 84.62 13.99 76.47 32.1"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "m84.62,13.99l-1.46-.85c.56-1.23,1.41-2.16,2.26-2.66.72-.42,1.44-.51,1.97-.2l1.46.85c-.53-.31-1.25-.21-1.97.2-.85.49-1.7,1.43-2.26,2.66"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "m95.87,22.6c.94,1.59-.42,4.87-2.44,6.04-.07.04-.15.08-.23.12l-14.66,7.15c-2.14,1.04-3.29-1.09-2.06-3.81l8.15-18.11c.56-1.23,1.41-2.16,2.26-2.66.99-.57,1.97-.54,2.48.32l6.51,10.95Zm-2.73,4.95c1.38-.79,2.3-3.02,1.66-4.1l-6.25-10.5c-.35-.58-1.01-.6-1.68-.22-.58.33-1.16.97-1.54,1.81l-7.82,17.37c-.83,1.85-.04,3.3,1.41,2.59l14.06-6.87c.05-.03.1-.05.15-.08"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmSystem);
export default __webpack_public_path__ + "static/media/alarm-system.3002ce2ce58e1ffa9f3dd802e720ac99.svg";
export { ForwardRef as ReactComponent };